var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// refs: https://usehooks.com/useOnClickOutside/
import { useEffect } from 'react';
export default function useOnClickOutside(ref, handler, _a) {
    var { includes = [] } = _a, props = __rest(_a, ["includes"]);
    useEffect(() => {
        const listener = (event) => {
            if (props === null || props === void 0 ? void 0 : props.disable) {
                return;
            }
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            if (includes.some((v) => event.target === v.current)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener, true);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, 
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler, props === null || props === void 0 ? void 0 : props.disable, includes]);
}
